// PricingPage.js
import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import PricingSection from '../../components/PricingSection/PricingSection';
import './PricingPage.css';

const PricingPage = () => {
    const faqs = [
        {
            question: "Comment fonctionne la facturation ?",
            answer: "La facturation est mensuelle. L'engagement annuel vous permet de bénéficier d'une remise de 20% sur le tarif mensuel."
        },
        {
            question: "Puis-je changer de forfait ?",
            answer: "Vous pouvez upgrader ou downgrader votre forfait mensuel à tout moment. Les ajustements de facturation seront calculés au prorata."
        },
        {
            question: "Y a-t-il une période d'essai ?",
            answer: "Oui, notre forfait \"gratuit\" inclu un essai sans engagement. Vous pouvez tester toutes les fonctionnalités avant de vous engager."
        },
        {
            question: "Quels sont les formats d'export supportés ?",
            answer: "Nous supportons l'export en MP3, WAV et MP4. Les forfaits Pro et Entreprise permettent également des formats personnalisés."
        }
    ];

    return (
        <div className="pricing-page">
            <div className="pricing-page__glass-bg">
                <div className="pricing-page__blob pricing-page__blob-1"></div>
                <div className="pricing-page__blob pricing-page__blob-2"></div>
            </div>

            <Navbar />

            {/* Use the PricingSection component here */}
            <PricingSection />

            <section className="pricing-page__faq">
                <h2 className="pricing-page__faq-title">Questions fréquentes</h2>
                {faqs.map((faq, index) => (
                    <div key={index} className="pricing-page__faq-item">
                        <h3 className="pricing-page__faq-question">{faq.question}</h3>
                        <p className="pricing-page__faq-answer">{faq.answer}</p>
                    </div>
                ))}
            </section>

            <Footer />
        </div>
    );
};

export default PricingPage;